var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _title, _title2, _radialGradient, _linearGradient14, _linearGradient15, _title3, _title4, _title5, _title6, _title7, _title8, _title9, _title10, _title11, _title12, _title13, _title14, _title15, _title16, _title17, _title18, _title19, _title20, _title21, _title22, _title23, _title24, _title25, _title26, _title27, _title28, _title29, _title30, _title31, _title32, _title33, _title34, _title35, _title36, _title37;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEzcash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 470 447.5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_3",
    gradientUnits: "userSpaceOnUse",
    x1: 23.367489,
    y1: 179.23578,
    x2: 47.46891,
    y2: 209.21402,
    gradientTransform: "matrix(0.77351, 0, 0, 0.77351, 13.8128, 25.338607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22F5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14ABEE"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_4",
    gradientUnits: "userSpaceOnUse",
    x1: 384.7515,
    y1: 516.54681,
    x2: 404.50967,
    y2: 544.64923,
    gradientTransform: "matrix(0.77351, 0, 0, 0.77351, 13.8128, 25.338607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF225E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF056E"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_6",
    gradientUnits: "userSpaceOnUse",
    x1: 361.41257,
    y1: 257.35934,
    x2: 396.10471,
    y2: 336.27191,
    gradientTransform: "matrix(0.77351, 0, 0, 0.77351, 13.8128, 25.338607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0E48B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#183CFD"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_7",
    gradientUnits: "userSpaceOnUse",
    x1: 288.17249,
    y1: 492.98486,
    x2: 288.15463,
    y2: 503.45493,
    gradientTransform: "matrix(0.77351, 0, 0, 0.77351, 13.8128, 25.338607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0E19B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123BE9"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_8",
    gradientUnits: "userSpaceOnUse",
    x1: 527.93536,
    y1: 445.26929,
    x2: 530.10901,
    y2: 475.95203,
    gradientTransform: "matrix(0.77351, 0, 0, 0.77351, 11.8128, 25.338608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF3048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB0093"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_10",
    gradientUnits: "userSpaceOnUse",
    x1: 136.3241,
    y1: 47.497463,
    x2: 154.33855,
    y2: 100.78331,
    gradientTransform: "matrix(0.77351, 0, 0, 0.77351, 13.8128, 25.338607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#52FCA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18D7D3"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_12",
    gradientUnits: "userSpaceOnUse",
    x1: 537.05042,
    y1: 249.17383,
    x2: 532.52716,
    y2: 378.31168,
    gradientTransform: "matrix(0.77351, 0, 0, 0.77351, 13.8128, 25.338607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#17EDC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0596F6"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_13",
    gradientUnits: "userSpaceOnUse",
    x1: 555.3396,
    y1: 265.34302,
    x2: 555.34827,
    y2: 281.4657,
    gradientTransform: "matrix(0.77351, 0, 0, 0.77351, 13.8128, 25.338607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#039EE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05BBF2"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_14",
    gradientUnits: "userSpaceOnUse",
    x1: 606.71912,
    y1: 309.91245,
    x2: 600.55499,
    y2: 310.96625,
    gradientTransform: "matrix(0.77351, 0, 0, 0.77351, 13.8128, 25.338607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0089C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BAAD8"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_16",
    gradientUnits: "userSpaceOnUse",
    x1: 276.64343,
    y1: 179.70972,
    x2: 256.45844,
    y2: 99.178215,
    gradientTransform: "matrix(0.77351, 0, 0, 0.77351, 13.8128, 25.338607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFEF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FFCD"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_17",
    gradientUnits: "userSpaceOnUse",
    x1: 287.52362,
    y1: 445.83652,
    x2: 249.50714,
    y2: 372.94495,
    gradientTransform: "matrix(0.77351, 0, 0, 0.77351, 13.8128, 25.338607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF691B"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_18",
    gradientUnits: "userSpaceOnUse",
    x1: 358.49316,
    y1: 402.20746,
    x2: 377.05182,
    y2: 451.90936,
    gradientTransform: "matrix(0.77351, 0, 0, 0.77351, 13.8128, 25.338607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFBC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE500"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_24",
    gradientUnits: "userSpaceOnUse",
    x1: 295.5282,
    y1: 415.36823,
    x2: 260.60974,
    y2: 148.8351,
    gradientTransform: "matrix(0.77351, 0, 0, 0.77351, 13.8128, 25.338607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFA901"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD901"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1,
    id: "gradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(249, 184, 1)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(255, 211, 18)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 403.878,
    y1: 65.949,
    x2: 403.878,
    y2: 104.338,
    id: "gradient-2",
    gradientTransform: "matrix(0.730598, -0.68281, 0.583779, 0.624634, 64.918495, 313.490241)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(251, 213, 28)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "rgb(181, 102, 3)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(152, 0, 0)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    cx: 49.169,
    cy: 68.962,
    r: 12.17,
    id: "gradient-4",
    gradientTransform: "matrix(0.41936, 1.627049, -1.60863, 0.414613, 155.912643, -47.667473)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(91.765% 96.863% 54.118%)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "rgb(249, 228, 30)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    style: {
      stopColor: "rgb(253, 196, 9)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253, 49, 90)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    cx: 34.738,
    cy: 421.864,
    r: 8.121,
    id: "gradient-3",
    gradientTransform: "matrix(0.640758, 1.206398, -1.748109, 0.92848, 770.445557, -15.31256)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(97.255% 89.412% 11.765%)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253, 140, 9)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    cx: 419.941,
    cy: 428.355,
    r: 12.29,
    id: "gradient-5",
    gradientTransform: "matrix(1.388062, 1.36201, -1.282289, 1.306817, 359.27417, -704.004639)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(249, 228, 30)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(254, 89, 45)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    cx: 353.595,
    cy: 250.783,
    r: 22.673,
    id: "gradient-6",
    gradientTransform: "matrix(1.079491, 1.444829, -1.177239, 0.879564, 318.882439, -480.539043)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(247, 250, 61)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    style: {
      stopColor: "rgb(252, 203, 18)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    style: {
      stopColor: "rgb(254, 89, 45)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(249, 28, 109)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 435.327,
    y1: 112.037,
    x2: 435.327,
    y2: 151.565,
    id: "gradient-7",
    gradientTransform: "matrix(0.799831, -0.600226, 0.633533, 0.844213, 5.48622, 280.801063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(4.3137% 61.961% 94.51%)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0% 37.605% 58.093%)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    cx: 794.642,
    cy: 575.369,
    r: 10.853,
    id: "gradient-8",
    gradientTransform: "matrix(0.020309, 1.411038, -1.110475, 0.015983, 1416.760174, -551.338212)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(97.647% 89.412% 11.765%)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(217, 199, 28)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-9"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Yellow dots")), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(249, 228, 30)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(217, 199, 28)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-10"
  }, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", null, "Wallet")), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(4, 0, 54)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(6, 55, 116)"
    }
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient-9-0",
    gradientUnits: "userSpaceOnUse",
    cx: 640.37,
    cy: 192.963,
    r: 3.379,
    xlinkHref: "#gradient-9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: -227.702,
    y1: 34.985,
    x2: -227.702,
    y2: 457.841,
    id: "gradient-12",
    gradientTransform: "matrix(0.933747, -0.357937, 0.211656, 0.552147, -26.3823, 1.61485)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(134, 254, 148)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(7, 137, 240)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 733.7,
    y1: 949.396,
    x2: 733.7,
    y2: 1372.252,
    id: "gradient-11",
    gradientTransform: "matrix(-0.88672, 0.462307, -0.187117, -0.358896, 485.089715, 273.894397)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(234, 32, 112)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "rgb(253, 196, 9)"
    }
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-10-0",
    gradientUnits: "userSpaceOnUse",
    x1: 230.078,
    y1: 102.354,
    x2: 230.078,
    y2: 406.229,
    spreadMethod: "pad",
    gradientTransform: "matrix(-0.999985, -0.005539, 0.006726, -1.214351, 456.602348, 530.843463)",
    xlinkHref: "#gradient-10"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-10-1",
    gradientUnits: "userSpaceOnUse",
    x1: -239.353,
    y1: -477.433,
    x2: -239.353,
    y2: -29.987,
    gradientTransform: "matrix(1, 0, 0, 1, 15, 29.999995)",
    xlinkHref: "#gradient-10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    points: "-376.707 429.305 -211.975 156.913 -435.11 98.332 -448.048 352.775"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 251.166,
    y1: 155.472,
    x2: 251.166,
    y2: 337.652,
    id: "gradient-13",
    gradientTransform: "matrix(0.741254, 0.671227, -0.834396, 0.921451, 273.823648, -151.24735)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 128, 31)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(240, 14, 105)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 230.406,
    y1: 359.816,
    x2: 230.406,
    y2: 391.132,
    id: "gradient-0",
    gradientTransform: "matrix(0.009546, -0.999958, 2.143367, 0.020461, -642.951164, 598.05861)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 72, 57)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(209, 7, 124)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 94.364,
    y1: 304.027,
    x2: 94.364,
    y2: 451.844,
    id: "gradient-14",
    gradientTransform: "matrix(0.733094, -0.680131, 0.81369, 0.877059, -298.635239, 113.922308)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(245, 30, 30)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(44.669% 0% 71.305%)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 60.046,
    y1: 321.94,
    x2: 60.046,
    y2: 427.885,
    id: "gradient-15",
    gradientTransform: "matrix(0.740745, -0.671788, 0.732096, 0.807249, -258.974846, 115.319458)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(81.961% 2.7451% 48.627%)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(54.694% 0% 30.429%)"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -469.769,
    y: -331.771,
    width: 46.455,
    height: 176.366,
    rx: 20,
    ry: 30,
    style: {
      fill: "rgb(6, 1, 78)",
      transformBox: "fill-box",
      transformOrigin: "50% 50%"
    },
    transform: "matrix(-1, 0, 0, -1, 893.083015, 487.175995)"
  }, _title3 || (_title3 = /*#__PURE__*/React.createElement("title", null, "Fold over"))), /*#__PURE__*/React.createElement("rect", {
    x: -448.615,
    y: -447.433,
    width: 448.524,
    height: 447.446,
    rx: 65,
    ry: 65,
    style: {
      fill: "url(&quot",
      transformBox: "fill-box",
      transformOrigin: "50% 50%"
    },
    transform: "matrix(-1, 0, 0, -1, 448.705994, 447.419952)"
  }, _title4 || (_title4 = /*#__PURE__*/React.createElement("title", null, "Wallet square"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.86551, 0, 0, 0.86551, 422.194757, 8.85654)",
    style: {}
  }, _title5 || (_title5 = /*#__PURE__*/React.createElement("title", null, "New circle")), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(&quot"
    },
    cx: -229,
    cy: 245.1,
    r: 211.428
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(&quot",
      clipPath: "url(&quot"
    },
    cx: -228.999,
    cy: 245.116,
    r: 211.428
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(1, 0, 0, 1, -15, -30)"
  }, _title6 || (_title6 = /*#__PURE__*/React.createElement("title", null, "Star")), /*#__PURE__*/React.createElement("path", {
    d: "M 386.271 84.999 C 386.271 80.493 396.003 81.328 398.294 77.873 C 401.448 74.868 400.439 66.399 403.727 65.949 C 407.879 66.116 407.449 75.079 409.645 77.961 C 412.618 81.864 421.418 81.238 421.485 85.18 C 421.553 89.192 413.968 89.201 410.516 92.016 C 406.545 95.254 407.423 103.893 403.562 104.326 C 400.008 104.724 400.825 95.371 397.94 92.065 C 395.65 89.442 386.271 89.273 386.271 84.999 Z",
    style: {
      fill: "url(&quot",
      transformBox: "fill-box",
      transformOrigin: "50% 50%"
    },
    transform: "matrix(1, 0, 0, 1, -0.000015258789, -0.000003814697)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -30)"
  }, _title7 || (_title7 = /*#__PURE__*/React.createElement("title", null, "Red/purple blob")), /*#__PURE__*/React.createElement("path", {
    d: "M 15.13 320.3 C 15.13 320.3 99.927 412.595 101.952 415.264 C 102.915 416.534 104.978 419.117 104.883 420.768 C 104.779 422.586 103.307 424.179 101.961 425.258 C 100.587 426.359 99.142 427.271 97.485 427.885 C 95.356 426 15.063 337.245 15.1 336.7 C 15.075 333.551 15.024 320.199 15.13 320.3 Z",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.075 304.027 C 15.017 304.043 133.633 435.516 138.41 438.25 C 139.212 438.709 140.095 439.137 141.004 439.32 C 145.965 440.317 156.577 439.753 162.102 439.75 C 164.489 439.749 167.073 439.591 169.398 440.215 C 171.887 440.883 174.184 442.667 174.349 445.406 C 174.442 446.959 174.078 448.748 173.031 449.946 C 171.573 451.613 168.87 451.629 166.814 451.684 C 160.016 451.866 128.129 452.366 123.356 450.887 C 119.312 449.634 115.95 446.901 112.945 444.012 C 107.589 438.862 102.997 432.919 97.555 427.885 C 99.212 427.271 100.657 426.359 102.031 425.258 C 103.377 424.179 104.849 422.586 104.953 420.768 C 105.048 419.117 102.985 416.534 102.022 415.264 C 99.997 412.595 15.087 321.341 15.123 321.338 C 15.08 321.268 15.075 304.027 15.075 304.027 Z",
    style: {
      fill: "url(&quot"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -30)"
  }, _title8 || (_title8 = /*#__PURE__*/React.createElement("title", null, "Blobs")), /*#__PURE__*/React.createElement("g", {
    style: {}
  }, _title9 || (_title9 = /*#__PURE__*/React.createElement("title", null, "Snap")), /*#__PURE__*/React.createElement("rect", {
    x: 386.451,
    y: 232.091,
    width: 97.029,
    height: 70.906,
    style: {},
    fill: "#060E4B"
  }, _title10 || (_title10 = /*#__PURE__*/React.createElement("title", null, "Wallet clip"))), /*#__PURE__*/React.createElement("path", {
    fill: "#86FE94",
    d: "M 390.463 227.68 C 395.142 224.534 400.235 221.935 405.731 220.571 C 413.281 218.697 421.35 219.172 429.072 219.203 L 453.659 219.343 C 448.997 221.729 430.207 221.394 424.388 221.625 C 419.274 221.83 413.869 222.153 408.814 222.942 C 402.765 223.886 396.902 226.175 391.296 228.575 C 390.841 228.325 390.741 228.105 390.463 227.68 Z",
    style: {}
  }, _title11 || (_title11 = /*#__PURE__*/React.createElement("title", null, "Fold top edge"))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_12)",
    d: "M 453.659 219.343 C 460.957 219.222 468.322 219.166 475.618 219.35 C 477.757 219.357 481.555 218.843 483.416 219.994 C 483.73 220.659 483.706 221.164 483.464 221.87 C 484.087 223.802 484.23 229.766 483.434 231.544 C 484.043 232.905 484.139 241.8 483.628 243.168 C 483.559 243.354 483.491 243.441 483.383 243.617 C 470.725 243.346 457.955 243.663 445.294 243.839 C 443.11 242.195 441.105 240.241 438.84 238.723 C 438.437 238.455 438.027 238.197 437.612 237.948 C 437.198 237.698 436.778 237.458 436.351 237.229 C 435.926 236.999 435.496 236.778 435.06 236.567 C 434.624 236.356 434.184 236.156 433.738 235.965 C 433.294 235.774 432.846 235.593 432.392 235.422 C 431.939 235.251 431.483 235.091 431.023 234.941 C 430.563 234.792 430.1 234.652 429.633 234.523 C 429.166 234.394 428.697 234.275 428.225 234.168 C 427.754 234.06 427.28 233.963 426.803 233.876 C 426.327 233.79 425.849 233.714 425.369 233.649 C 424.889 233.584 424.409 233.53 423.927 233.487 C 423.445 233.444 422.963 233.411 422.478 233.39 C 421.995 233.369 421.512 233.358 421.027 233.359 C 420.543 233.359 420.06 233.37 419.576 233.393 C 419.093 233.415 418.61 233.448 418.127 233.493 C 417.646 233.537 417.165 233.592 416.686 233.657 C 411.588 234.398 406.27 236.244 402.067 239.264 C 400.627 240.298 399.353 241.523 397.945 242.579 C 396.382 244.278 394.586 245.9 393.211 247.753 C 388.907 253.553 386.557 261.304 386.848 268.507 C 387.204 277.337 391.573 285.891 398.049 291.845 C 405.112 298.337 414.507 300.407 423.887 299.957 C 427.38 299.79 430.749 298.665 434.232 298.44 C 441.382 297.978 448.837 298.562 456.015 298.583 C 464.014 298.607 472.347 298.023 480.302 298.803 C 481.298 298.798 482.324 298.73 483.305 298.923 C 484.051 301.052 483.459 305.414 483.415 307.808 C 483.825 309.112 484.086 319.578 483.57 320.542 C 483.521 320.634 483.345 320.833 483.272 320.918 C 482.26 321.547 476.834 321.286 475.378 321.275 C 466.807 321.649 458.053 321.294 449.467 321.289 C 438.307 321.284 421.398 322.143 410.771 319.44 C 409.937 319.221 409.108 318.983 408.284 318.724 C 407.461 318.466 406.645 318.188 405.835 317.89 C 405.025 317.592 404.223 317.276 403.428 316.94 C 402.634 316.603 401.848 316.249 401.07 315.875 C 400.293 315.502 399.524 315.109 398.765 314.699 C 398.007 314.288 397.258 313.859 396.519 313.413 C 395.781 312.967 395.054 312.503 394.338 312.022 C 393.623 311.54 392.919 311.042 392.226 310.527 C 391.534 310.012 390.854 309.481 390.187 308.933 C 389.521 308.385 388.869 307.822 388.228 307.243 C 387.589 306.664 386.963 306.07 386.352 305.461 C 385.741 304.853 385.145 304.229 384.563 303.592 C 383.982 302.954 383.417 302.303 382.866 301.639 C 382.316 300.974 381.782 300.297 381.264 299.607 C 380.747 298.917 380.246 298.214 379.762 297.5 C 379.278 296.786 378.811 296.061 378.362 295.325 C 378.207 295.178 378.266 295.246 378.113 295.024 C 371.154 284.894 369.268 269.765 371.582 257.943 C 373.841 246.408 380.529 234.317 390.463 227.68 C 390.741 228.105 390.841 228.325 391.296 228.575 C 396.902 226.175 402.765 223.886 408.814 222.942 C 413.869 222.153 419.274 221.83 424.388 221.625 C 430.207 221.394 448.997 221.729 453.659 219.343 Z",
    style: {}
  }, _title12 || (_title12 = /*#__PURE__*/React.createElement("title", null, "Fold, outer border"))), /*#__PURE__*/React.createElement("path", {
    fill: "#0B9EF1",
    d: "M 475.618 219.35 C 477.757 219.357 481.555 218.843 483.416 219.994 C 483.73 220.659 483.706 221.164 483.464 221.87 C 484.087 223.802 484.23 229.766 483.434 231.544 C 483.44 231.486 483.45 231.428 483.453 231.37 C 483.491 230.491 483.591 229.488 482.985 228.855 L 483.194 228.761 L 483.018 228.902 C 482.88 229.454 482.76 229.918 482.462 230.412 C 480.374 230.932 475.227 231.098 473.126 230.419 L 477.877 230.33 C 478.553 229.138 478.002 221.638 477.999 219.663 C 477.198 219.59 476.412 219.476 475.618 219.35 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FC2EE",
    d: "M 378.362 295.325 C 380.037 295.746 381.642 298.702 382.704 300.079 C 384.892 302.915 388.304 305.608 391.25 307.599 C 395.027 310.151 399.017 312.782 403.262 314.476 C 406.839 315.904 410.709 317.074 414.507 317.698 C 419.338 318.49 424.275 318.418 429.157 318.497 C 435.571 318.631 441.985 318.643 448.399 318.531 C 454.55 318.406 460.764 318.079 466.911 318.282 C 468.55 317.646 470.652 317.683 472.399 317.376 C 473.921 317.108 475.435 316.657 476.915 316.219 C 478.532 316.662 482.299 317.041 483.296 318.408 C 483.67 318.92 483.607 319.733 483.472 320.326 C 483.399 320.646 483.383 320.659 483.272 320.918 C 482.26 321.547 476.834 321.286 475.378 321.275 C 466.807 321.649 458.053 321.294 449.467 321.289 C 438.307 321.284 421.398 322.143 410.771 319.44 C 409.937 319.221 409.108 318.983 408.284 318.724 C 407.461 318.466 406.645 318.188 405.835 317.89 C 405.025 317.592 404.223 317.276 403.428 316.94 C 402.634 316.603 401.848 316.249 401.07 315.875 C 400.293 315.502 399.524 315.109 398.765 314.699 C 398.007 314.288 397.258 313.859 396.519 313.413 C 395.781 312.967 395.054 312.503 394.338 312.022 C 393.623 311.54 392.919 311.042 392.226 310.527 C 391.534 310.012 390.854 309.481 390.187 308.933 C 389.521 308.385 388.869 307.822 388.228 307.243 C 387.589 306.664 386.963 306.07 386.352 305.461 C 385.741 304.853 385.145 304.229 384.563 303.592 C 383.982 302.954 383.417 302.303 382.866 301.639 C 382.316 300.974 381.782 300.297 381.264 299.607 C 380.747 298.917 380.246 298.214 379.762 297.5 C 379.278 296.786 378.811 296.061 378.362 295.325 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B9EF1",
    d: "M 476.915 316.219 C 478.532 316.662 482.299 317.041 483.296 318.408 C 483.67 318.92 483.607 319.733 483.472 320.326 C 483.399 320.646 483.383 320.659 483.272 320.918 C 482.26 321.547 476.834 321.286 475.378 321.275 C 476.682 320.935 478.162 320.908 479.506 320.78 L 479.472 320.46 C 476.753 318.438 470.297 318.466 466.911 318.282 C 468.55 317.646 470.652 317.683 472.399 317.376 C 473.921 317.108 475.435 316.657 476.915 316.219 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_13)",
    d: "M 473.126 230.419 C 475.227 231.098 480.374 230.932 482.462 230.412 C 482.76 229.918 482.88 229.454 483.018 228.902 L 483.194 228.761 L 482.985 228.855 C 483.591 229.488 483.491 230.491 483.453 231.37 C 483.45 231.428 483.44 231.486 483.434 231.544 C 484.043 232.905 484.139 241.8 483.628 243.168 C 483.559 243.354 483.491 243.441 483.383 243.617 C 470.725 243.346 457.955 243.663 445.294 243.839 C 443.11 242.195 441.105 240.241 438.84 238.723 C 438.437 238.455 438.027 238.197 437.612 237.948 C 437.198 237.698 436.778 237.458 436.351 237.229 C 435.926 236.999 435.496 236.778 435.06 236.567 C 434.624 236.356 434.184 236.156 433.738 235.965 C 433.294 235.774 432.846 235.593 432.392 235.422 C 431.939 235.251 431.483 235.091 431.023 234.941 C 430.563 234.792 430.1 234.652 429.633 234.523 C 429.166 234.394 428.697 234.275 428.225 234.168 C 427.754 234.06 427.28 233.963 426.803 233.876 C 426.327 233.79 425.849 233.714 425.369 233.649 C 424.889 233.584 424.409 233.53 423.927 233.487 C 423.445 233.444 422.963 233.411 422.478 233.39 C 421.995 233.369 421.512 233.358 421.027 233.359 C 420.543 233.359 420.06 233.37 419.576 233.393 C 419.093 233.415 418.61 233.448 418.127 233.493 C 417.646 233.537 417.165 233.592 416.686 233.657 C 411.588 234.398 406.27 236.244 402.067 239.264 C 400.627 240.298 399.353 241.523 397.945 242.579 C 399.009 240.341 399.077 238.462 400.596 236.763 C 401.473 235.784 401.981 234.582 404.997 233.441 C 416.948 228.922 431.884 230.429 444.428 230.427 C 453.976 230.426 463.586 230.125 473.126 230.419 Z",
    style: {}
  }, _title13 || (_title13 = /*#__PURE__*/React.createElement("title", null, "Fold, inner border top"))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_14)",
    d: "M 474.45 261.074 C 477.431 261.01 480.408 261.073 483.383 261.262 C 483.637 261.699 483.721 261.946 483.76 262.461 C 483.951 264.964 484.066 279.173 483.604 281.1 L 483.262 281.499 C 483.762 280.108 482.975 277.74 482.829 276.305 C 482.645 274.486 482.852 272.644 482.668 270.824 C 480.571 270.173 478.016 270.36 475.844 270.387 L 476.647 270.213 C 477.116 270.115 477.532 270.09 477.903 269.754 C 478.481 269.229 477.524 262.809 477.467 261.634 L 476.92 261.539 L 476.944 261.494 C 476.162 261.402 475.4 261.3 474.634 261.118 L 474.45 261.074 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FC2EE",
    d: "M 456.406 260.817 C 462.365 260.686 468.487 260.896 474.45 261.074 L 474.634 261.118 C 475.4 261.3 476.162 261.402 476.944 261.494 L 476.92 261.539 L 477.467 261.634 C 477.524 262.809 478.481 269.229 477.903 269.754 C 477.532 270.09 477.116 270.115 476.647 270.213 L 475.844 270.387 C 470.683 271 462.204 271.348 457.023 270.889 C 457.021 267.548 456.712 264.145 456.406 260.817 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B9EF1",
    d: "M 475.844 270.387 C 478.016 270.36 480.571 270.173 482.668 270.824 C 482.852 272.644 482.645 274.486 482.829 276.305 C 482.975 277.74 483.762 280.108 483.262 281.499 C 482.253 282.057 459.144 281.76 456.287 281.627 C 456.569 278.051 456.814 274.472 457.023 270.889 C 462.204 271.348 470.683 271 475.844 270.387 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(&quot"
    },
    cx: 419.11,
    cy: 266.975,
    r: 22.673
  }, _title14 || (_title14 = /*#__PURE__*/React.createElement("title", null, "Button")))), /*#__PURE__*/React.createElement("g", null, _title15 || (_title15 = /*#__PURE__*/React.createElement("title", null, "Yellow/red blob")), /*#__PURE__*/React.createElement("path", {
    fill: "#FDC409",
    d: "M 33.991 227.89 C 34.022 224.772 33.126 218.083 35.505 215.932 C 36.26 215.248 37.284 215.03 38.278 215.136 C 39.165 215.231 39.966 215.653 40.522 216.355 C 42.547 218.917 41.895 224.906 41.99 228.103 C 40.143 228.301 38.183 228.626 36.328 228.539 C 35.58 228.504 34.526 228.47 33.991 227.89 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F91C6D",
    d: "M 33.991 227.89 C 34.526 228.47 35.58 228.504 36.328 228.539 C 38.183 228.626 40.143 228.301 41.99 228.103 C 42.359 231.594 42.8 237.987 40.477 240.804 C 39.891 241.515 38.971 242.169 38.009 242.159 C 37.001 242.148 36.18 241.659 35.522 240.915 C 32.923 237.975 33.704 231.602 33.991 227.89 Z",
    style: {}
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1EF5",
    d: "M 442.911 342.547 C 445.575 342.564 448.35 343.385 450.288 345.283 C 451.444 346.415 452.3 348.008 452.31 349.654 C 452.317 350.722 451.92 351.717 451.132 352.444 C 450.024 353.467 448.636 353.737 447.19 353.936 C 440.922 354.799 433.987 354.208 427.646 354.182 C 420.921 354.156 414.155 354.511 407.442 354.047 C 405.814 353.934 404.211 353.737 402.615 353.387 C 404.45 351.262 404.443 348.249 405.586 345.791 C 406.03 344.834 406.668 343.997 407.302 343.159 C 415.09 343.029 422.891 343.132 430.68 343.138 C 434.206 343.14 437.986 343.408 441.487 343.048 C 442.094 342.986 442.425 342.912 442.911 342.547 Z",
    style: {}
  }, _title16 || (_title16 = /*#__PURE__*/React.createElement("title", null, "Purple blob"))), /*#__PURE__*/React.createElement("path", {
    d: "M 430.874 112.038 C 433.265 112.01 435.071 112.987 436.881 114.448 C 439.633 116.67 447.345 125.039 449.135 128.101 C 449.626 128.939 449.848 129.756 449.933 130.718 C 450.134 133.028 449.831 135.462 449.831 137.788 C 449.832 140.773 450.275 144.041 449.861 146.978 C 449.676 148.287 449.246 149.633 448.369 150.65 C 447.894 151.2 447.273 151.569 446.528 151.565 C 444.847 151.555 443.834 150.397 442.724 149.308 C 438.583 145.13 434.625 140.808 430.579 136.542 C 427.893 133.709 424.797 130.887 422.53 127.71 C 421.662 126.494 421.004 125.183 420.747 123.699 C 420.295 121.082 421.04 118.351 422.651 116.255 C 424.772 113.496 427.551 112.466 430.874 112.038 Z",
    style: {
      fill: "url(&quot"
    }
  }, _title17 || (_title17 = /*#__PURE__*/React.createElement("title", null, "Blue blob"))), /*#__PURE__*/React.createElement("path", {
    fill: "#F91C6D",
    d: "M 407.55 140.1 C 407.818 140.11 408.074 140.121 408.339 140.164 C 409.91 140.421 411.245 141.749 412.337 142.833 C 417.211 147.669 422.048 154.212 426.656 159.5 L 436.866 171.052 C 439.406 173.919 442.057 176.756 444.193 179.944 C 446.51 183.398 447.936 187.587 447.018 191.766 C 446.393 194.614 444.716 196.27 442.366 197.79 C 440.614 198.668 439.247 198.973 437.316 198.449 C 434.879 197.789 432.9 195.987 431.517 193.934 C 429.341 190.706 428.138 186.893 426.59 183.347 C 424.764 179.162 422.679 174.97 420.404 171.009 C 418.063 166.953 415.522 163.026 412.78 159.229 C 410.23 155.728 407.261 152.27 405.221 148.454 C 404.388 146.894 403.548 145.135 404.166 143.341 C 404.697 141.798 406.159 140.8 407.55 140.1 Z",
    style: {}
  }, _title18 || (_title18 = /*#__PURE__*/React.createElement("title", null, "Red blob"))), /*#__PURE__*/React.createElement("path", {
    fill: "#F91C6D",
    d: "M 15.1 249.3 C 15.1 249.3 32.335 268.119 40.498 276.91 C 43.847 280.588 48.344 284.767 51.118 288.799 C 52.314 290.537 53.145 292.04 53.055 294.23 C 52.955 296.611 51.911 299.008 50.106 300.586 C 48.493 301.998 45.689 303.027 43.53 302.889 C 41.846000000000004 302.783 39.958 301.882 38.61 300.878 C 35.432 298.511 32.756 295.074 30.09 292.152 C 25.03 286.606 19.997 281.07 15.1 275.3 C 15.052 273.598 15.1 251.3 15.1 249.3 Z",
    style: {}
  }, _title19 || (_title19 = /*#__PURE__*/React.createElement("title", null, "Red blob"))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_3)",
    d: "M 49.726 151.885 C 56.474 152.033 58.737 157.665 58.879 157.989 C 59.332 159 59.585 160.069 59.706 161.168 C 59.962 163.494 59.955 172.856 59.219 174.536 C 57.823 177.72 41.686 194.509 38.434 197.64 C 35.697 200.275 33.938 200.357 33.739 200.409 C 31.991 200.871 30.833 200.685 29.299 199.719 C 27.078 198.319 25.576 196.114 24.742 193.572 C 24.364 192.419 24.493 191.914 24.677 190.814 C 25.479 186.005 31.722 180.208 35.112 176.797 C 36.462 175.437 38.168 173.989 38.981 172.233 C 41.088 167.684 37.442 161.766 41.504 156.196 C 43.434 153.55 46.384 151.812 49.726 151.885 Z",
    style: {}
  }, _title20 || (_title20 = /*#__PURE__*/React.createElement("title", null, "Cyan blob"))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_4)",
    d: "M 341.585 413.082 C 341.667 413.074 341.748 413.064 341.829 413.058 C 344.137 412.893 346.721 413.104 348.524 414.703 C 349.937 415.957 350.973 418.054 351.015 419.951 C 351.089 423.176 348.743 425.608 346.622 427.742 C 342.603 431.786 325.294 449.555 321.221 450.809 C 317.064 452.09 311.849 451.572 307.549 451.557 L 293.565 451.547 C 291.102 451.604 288.281 451.932 286.009 450.81 C 284.91 450.267 283.8 449.358 283.426 448.147 C 283 446.765 283.643 445.177 284.302 443.978 C 286.455 440.068 294.803 441.829 298.673 441.264 C 301.281 440.884 303.878 439.842 306.142 438.509 C 312.288 434.89 319.874 428.337 325.458 423.784 C 330.389 419.765 335.348 414.881 341.585 413.082 Z",
    style: {}
  }, _title21 || (_title21 = /*#__PURE__*/React.createElement("title", null, "Red blob"))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_8)",
    d: "M 388.134 373.095 C 390.458 372.099 392.63 371.442 395.157 371.216 C 401.919 370.61 410.462 371.119 417.488 371.103 C 427.446 371.079 437.629 370.618 447.571 371.113 C 449.511 371.21 451.775 371.318 453.595 372.056 C 457.124 373.487 461.216 376.946 462.605 380.666 C 462.854 381.412 462.833 390.929 462.092 391.417 C 461.658 391.518 451.525 391.594 446.245 391.586 L 401.944 391.576 C 394.625 391.562 387.284 391.709 379.97 391.457 C 378.659 391.443 377.878 390.886 377.912 386.792 C 377.947 382.538 383.437 374.973 388.134 373.095 Z",
    style: {}
  }, _title22 || (_title22 = /*#__PURE__*/React.createElement("title", null, "Red blob"))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_10)",
    d: "M 152.31 53.176 C 156.857 53.107 166.382 52.376 170.486 53.511 C 171.85 53.889 173.161 54.624 174.154 55.639 C 175.121 56.626 175.615 57.833 175.559 59.218 C 175.494 60.87 174.797 62.368 173.568 63.47 C 170.563 66.165 166.181 65.976 162.418 66.003 C 158.019 66.035 153.22 65.738 148.988 67.097 C 143.768 68.775 138.596 71.837 134.371 75.307 C 130.068 78.842 126.165 83.078 122.308 87.093 L 104.526 105.884 C 100.95 109.655 97.325 114.183 93.034 117.102 C 91.106 118.413 88.7 119.3 86.347 119.073 C 84.103 118.856 82.096 117.598 80.715 115.849 C 79.215 113.951 78.458 111.438 78.784 109.03 C 79.072 106.895 80.164 104.978 81.429 103.274 C 83.294 100.76 85.606 98.548 87.725 96.247 C 91.616 91.953 95.553 87.701 99.535 83.491 L 112.04 70.184 C 115.461 66.558 118.896 62.715 122.815 59.613 C 132.966 51.628 140.207 53.244 152.31 53.176 Z",
    style: {}
  }, _title23 || (_title23 = /*#__PURE__*/React.createElement("title", null, "Cyan blob"))), /*#__PURE__*/React.createElement("path", {
    fill: "#86FE94",
    d: "M 122.815 59.613 C 132.966 51.628 140.207 53.244 152.31 53.176 C 152.206 53.276 152.1 53.377 151.997 53.479 C 151.712 53.761 151.53 54.021 151.326 54.364 C 150.99 54.929 150.797 55.071 150.144 55.239 C 146.848 56.09 143.079 55.823 139.694 56.056 C 136.352 56.285 133.13 57.238 129.983 58.337 C 128.426 58.882 124.997 60.864 123.532 60.311 L 122.815 59.613 Z",
    style: {}
  }, _title24 || (_title24 = /*#__PURE__*/React.createElement("title", null, "Cyan blob top side")))), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(1, 0, 0, 1, -15, -30)"
  }, _title25 || (_title25 = /*#__PURE__*/React.createElement("title", null, "Z")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(&quot",
      paintOrder: "fill"
    },
    d: "M 326.127 102.766 C 345.42 102.555 363.214 118.709 362.986 134.758 L 363.491 179.846 C 358.525 203.746 337.398 210.609 335.673 210.736 L 254.283 310.207 L 332.367 310.694 C 351.166 310.417 364.489 326.747 364.126 345.629 L 362.856 388.186 C 360.58 397.927 349.832 405.128 339.989 405.336 L 120.926 406.229 C 109.482 406.042 98.27 393.244 97.985 384.375 C 97.98 384.589 95.887 347.084 96.08 338.007 C 94.857 330.322 109.539 309.853 109.686 310.776 C 138.481 273.724 198.998 199.402 196.438 199.537 C 195.731 199.574 119.909 199.784 116.333 197.899 C 112.466 195.86 100.181 192.345 97.35 173.495 C 94.866 156.953 94.654 140.226 96.715 123.315 C 98.358 109.834 110.003 102.848 131.65 102.354 L 326.127 102.766 Z"
  }, _title26 || (_title26 = /*#__PURE__*/React.createElement("title", null, "Full Z shape w/o shadow"))), /*#__PURE__*/React.createElement("g", {
    style: {}
  }, _title27 || (_title27 = /*#__PURE__*/React.createElement("title", null, "Shadow")), /*#__PURE__*/React.createElement("path", {
    fill: "#8C0284",
    d: "M 99.618 181.897 C 100.813 183.34 102.481 187.72 103.971 189.329 C 106.953 192.548 112.26 195.914 116.374 197.729 C 119.133 198.946 140.333 199.125 148.795 199.097 C 162.532 199.05 176.248 199.016 189.976 199.387 C 192.322 199.45 194.592 199.4 196.932 199.488 C 196.026 202.91 187.907 212.257 187.248 212.906 C 185.884 212.188 135.341 212.706 128.859 212.652 C 122.572 212.335 117.352 212.023 111.985 208.315 C 103.687 202.581 101.372 191.471 99.618 181.897 Z",
    style: {}
  }, _title28 || (_title28 = /*#__PURE__*/React.createElement("title", null, "Purple Shadow under Z top"))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_6)",
    d: "M 253.741 310.511 C 256.589 306.102 314.521 235.021 332.434 214.364 C 335.285 211.076 334.216 211.308 334.938 211.046 C 341.176 208.782 348.758 206.098 357.574 194.294 C 356.004 199.206 355.154 205.206 352.032 209.354 C 349.837 212.27 347.139 214.685 344.17 216.786 C 341.852 218.425 339.37 219.939 337.47 222.079 C 334.964 224.903 266.287 306.96 265.338 310.515 C 261.476 310.475 257.601 310.372 253.741 310.511 Z",
    style: {}
  }, _title29 || (_title29 = /*#__PURE__*/React.createElement("title", null, "Blue Shadow on Z's right"))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_7)",
    d: "M 142.057 406.128 C 146.131 405.397 335.105 404.668 337.176 405.44 L 329.923 410.111 C 319.971 414.135 141.804 418.452 142.057 406.128 Z",
    style: {}
  }, _title30 || (_title30 = /*#__PURE__*/React.createElement("title", null, "Blue shadow beneath Z")))), /*#__PURE__*/React.createElement("path", {
    d: "M 343.067 361.87 L 343.017 370.763 C 342.987 376.497 343.1 382.36 338.728 386.689 C 336.194 389.199 332.788 390.355 329.308 390.766 C 323.553 391.446 132.454 390.979 131.31 390.929 C 114.639 390.235 117.733 370.909 118.413 362.436 C 118.865 356.808 173.548 362.02 174.049 361.881 C 174.049 361.881 323.659 362.1 343.067 361.87 Z",
    style: {
      fill: "url(&quot"
    }
  }, _title31 || (_title31 = /*#__PURE__*/React.createElement("title", null, "Maroon at Z bottom"))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_16)",
    d: "M 118.445 155.354 C 118.46 151.663 118.545 147.943 118.386 144.254 C 118.262 141.381 117.898 138.505 117.868 135.63 C 117.831 132.036 118.815 129.03 121.414 126.48 C 123.364 124.565 126.041 123.239 128.709 122.684 C 134.251 121.532 141.909 122.118 147.633 122.134 L 176.635 122.167 L 266.508 122.17 L 301.388 122.171 C 308.628 122.177 315.888 122.082 323.124 122.344 C 325.515 122.274 331.903 123.926 331.554 124.415 C 331.554 124.415 312.297 131.492 305.358 135.995 C 302.857 137.618 300.262 139.103 297.738 140.691 C 289.58 145.824 279.142 152.838 269.592 154.328 C 262.84 155.381 256.035 155.272 249.223 155.313 C 243.007 155.402 236.79 155.447 230.573 155.448 L 150.225 155.332 C 143.424 155.381 136.622 155.377 129.822 155.318 C 126.107 155.295 122.135 154.986 118.445 155.354 Z",
    style: {}
  }, _title32 || (_title32 = /*#__PURE__*/React.createElement("title", null, "Yellow horizontal on Z"))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_17)",
    d: "M 208.51 328.494 C 228.945 329.289 249.485 328.738 269.938 328.865 L 283.564 328.899 C 285.982 328.898 288.464 328.766 290.87 328.955 C 299.332 328.725 307.821 328.852 316.287 328.872 C 321.664 328.886 329.144 328.263 334.26 329.524 C 336.029 329.959 337.754 331.05 339.07 332.283 C 341.729 334.772 342.781 337.813 342.872 341.363 C 343.047 348.19 342.989 355.04 343.067 361.87 C 323.659 362.1 304.241 361.838 284.832 361.889 L 261.383 361.91 C 257.599 361.904 253.644 362.136 249.878 361.856 C 241.187 362.175 232.371 361.905 223.671 361.899 L 174.049 361.881 L 145.897 361.841 C 140.942 361.843 135.958 362.017 131.007 361.873 C 134.156 361.356 138.24 358.512 140.433 356.866 C 144.697 353.667 148.857 349.805 152.452 345.864 C 155.514 342.507 158.314 339.004 161.684 335.932 C 161.331 336.515 160.998 336.793 161.104 337.481 C 162.91 338.455 168.585 334.989 170.493 334.121 C 181.414 329.15 193.093 328.91 204.854 328.503 L 208.51 328.494 Z",
    style: {}
  }, _title33 || (_title33 = /*#__PURE__*/React.createElement("title", null, "Orange at Z bottom"))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_18)",
    d: "M 290.87 328.955 C 299.332 328.725 307.821 328.852 316.287 328.872 C 321.664 328.886 329.144 328.263 334.26 329.524 C 336.029 329.959 337.754 331.05 339.07 332.283 C 341.729 334.772 342.781 337.813 342.872 341.363 C 343.047 348.19 342.989 355.04 343.067 361.87 C 323.659 362.1 304.241 361.838 284.832 361.889 L 261.383 361.91 C 257.599 361.904 253.644 362.136 249.878 361.856 L 248.514 361.545 L 248.54 361.428 C 249.923 361.211 251.469 361.32 252.794 360.882 C 253.166 360.759 253.448 360.696 253.843 360.678 C 254.253 360.658 254.29 360.656 254.696 360.468 C 254.454 359.997 254.325 359.981 254.456 359.444 C 257.469 357.139 261.028 355.523 264.124 353.279 C 265.276 352.444 266.655 350.515 267.948 350.094 C 269.228 349.678 270.44 348.544 271.714 347.95 C 274.719 346.546 277.735 345.18 280.693 343.676 C 281.69 343.17 282.589 342.489 283.597 342.013 C 286.529 340.627 289.578 339.387 292.557 338.098 C 298.223 335.649 304.177 334.162 309.832 331.61 C 311.001 331.082 312.271 330.639 313.326 329.911 C 311.797 329.666 310.231 329.274 308.682 329.215 C 305.072 329.077 293.82 330.016 291.252 329.103 C 291.124 329.057 290.998 329.005 290.87 328.955 Z",
    style: {}
  }, _title34 || (_title34 = /*#__PURE__*/React.createElement("title", null, "Brighter orange at Z bottom"))), /*#__PURE__*/React.createElement("path", {
    d: "M 341.246 155.472 C 341.242 157.461 341.296 159.471 340.991 161.442 L 340.909 170.695 C 340.844 176.162 341.031 181.235 336.844 185.341 C 333.497 188.624 328.608 189.433 324.089 189.333 C 322.948 189.308 321.809 189.232 320.674 189.105 C 317.343 192.124 314.65 196.22 311.797 199.714 L 291.397 224.768 L 243.603 283.511 C 236.437 292.326 228.874 300.818 221.944 309.828 C 219.851 312.873 208.631 325.172 208.693 327.913 L 208.51 328.494 L 204.854 328.503 C 193.093 328.91 181.414 329.15 170.493 334.121 C 168.585 334.989 162.91 338.455 161.104 337.481 C 160.998 336.793 161.331 336.515 161.684 335.932 C 164.589 332.727 167.119 329.234 169.826 325.866 C 173.824 320.892 177.912 316 181.873 310.994 C 192.703 297.34 203.659 283.79 214.743 270.343 C 219.68 264.332 224.351 258.044 229.532 252.243 C 234.734 245.469 240.256 238.955 245.654 232.339 L 272.845 199.154 L 287.938 180.791 C 292.14 175.675 296.369 170.448 300.982 165.697 C 312.538 153.792 326.143 155.696 341.246 155.472 Z",
    style: {
      fill: "url(&quot"
    }
  }, _title35 || (_title35 = /*#__PURE__*/React.createElement("title", null, "red diagonal on Z"))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_24)",
    d: "M 329.807 124.196 C 332.304 124.128 335.372 126.217 337.621 128.773 C 341.295 133.699 341.231 138.83 341.228 144.738 C 341.227 148.312 341.151 151.898 341.246 155.472 C 326.143 155.696 312.538 153.792 300.982 165.697 C 296.369 170.448 292.14 175.675 287.938 180.791 L 272.845 199.154 L 245.654 232.339 C 240.256 238.955 234.734 245.469 229.532 252.243 C 224.351 258.044 219.68 264.332 214.743 270.343 C 203.659 283.79 192.703 297.34 181.873 310.994 C 177.912 316 173.824 320.892 169.826 325.866 C 167.119 329.234 164.589 332.727 161.684 335.932 C 158.314 339.004 155.514 342.507 152.452 345.864 C 148.857 349.805 144.697 353.667 140.433 356.866 C 138.24 358.512 134.156 361.356 131.007 361.873 C 126.817 362.266 122.598 361.971 118.399 361.929 C 118.416 356.471 117.671 339.286 119.394 335.356 C 121.509 330.535 125.396 326.592 128.722 322.591 L 137.619 311.807 L 160.353 283.829 L 245.032 178.411 C 234.768 177.946 224.322 178.306 214.037 178.306 L 156.276 178.321 L 136.117 178.354 C 132.411 178.369 128.491 178.633 124.813 178.22 C 123.402 178.062 122.077 177.545 121.056 176.537 C 119.922 175.419 119.184 173.931 118.802 172.397 C 117.747 168.166 118.393 159.941 118.445 155.354 C 122.135 154.986 126.107 155.295 129.822 155.318 C 136.622 155.377 143.424 155.382 150.225 155.332 L 230.573 155.448 C 236.79 155.447 243.007 155.402 249.223 155.313 C 256.035 155.272 262.84 155.381 269.592 154.328 C 279.142 152.838 289.58 145.824 297.738 140.691 C 300.262 139.103 302.857 137.618 305.358 135.995 C 312.297 131.492 321.192 124.748 329.807 124.196 Z",
    style: {}
  }, _title36 || (_title36 = /*#__PURE__*/React.createElement("title", null, "Yellow diagonal on Z")))), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(1, 0, 0, 1, -15, -30)"
  }, _title37 || (_title37 = /*#__PURE__*/React.createElement("title", null, "Dots")), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(253, 196, 9)"
    },
    cx: 369.203,
    cy: 90.422,
    r: 3.605
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(253, 196, 9)"
    },
    cx: 344.634,
    cy: 76.064,
    r: 4.137
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(249, 228, 30)"
    },
    cx: 372.621,
    cy: 62.207,
    r: 6.322
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(249, 228, 30)"
    },
    cx: 324.895,
    cy: 62.553,
    r: 5.425
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(253, 196, 9)"
    },
    transform: "matrix(1, 0, 0, 1.000004, -424.784122, -370.508609)",
    cx: 522.963,
    cy: 660,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(253, 196, 9)"
    },
    transform: "matrix(1, 0, 0, 1.000004, -249.184114, -68.847825)",
    cx: 335.185,
    cy: 335.926,
    r: 7.261
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(&quot"
    },
    transform: "matrix(1, 0, 0, 1.000004, -533.744694, 64.988587)",
    cx: 640.37,
    cy: 192.963,
    r: 3.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(249, 228, 30)"
    },
    transform: "matrix(1, 0, 0, 1.000004, -281.664889, -282.328036)",
    cx: 381.111,
    cy: 510,
    r: 4.251
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(&quot"
    },
    transform: "matrix(1, 0, 0, 1.000004, -661.54627, -348.086795)",
    cx: 794.074,
    cy: 585.926,
    r: 10.853
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(22, 32, 114)"
    },
    transform: "matrix(1, 0, 0, 1.000004, -769.785406, -246.593416)",
    cx: 805.926,
    cy: 647.407,
    r: 4.15
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(253, 49, 90)"
    },
    transform: "matrix(1, 0, 0, 1.000004, -1038.809334, -486.574375)",
    cx: 1108.519,
    cy: 927.037,
    r: 4.931
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(&quot"
    },
    transform: "matrix(1, 0, 0, 1.000004, -243.525667, -430.537845)",
    cx: 308.519,
    cy: 561.852,
    r: 4.859
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(30, 230, 216)"
    },
    transform: "matrix(1, 0, 0, 1.000004, -575.751347, -275.810213)",
    cx: 625.185,
    cy: 372.593,
    r: 5.032
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(&quot"
    },
    cx: 68.087,
    cy: 69.5,
    r: 12.17
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(&quot"
    },
    cx: 56.346,
    cy: 421.61,
    r: 8.121
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(&quot"
    },
    cx: 400.687,
    cy: 436.241,
    r: 12.29
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(253, 140, 8)"
    },
    cx: 382.918,
    cy: 417.038,
    r: 3.943
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(253, 49, 90)"
    },
    cx: 364.022,
    cy: 444.537,
    r: 4.814
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(249, 28, 109)"
    },
    cx: 433.358,
    cy: 418.215,
    r: 7.374
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(253, 196, 9)"
    },
    cx: 82.566,
    cy: 318.22,
    r: 3.498
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(249, 28, 109)"
    },
    cx: 216.735,
    cy: 453.31,
    r: 6.854
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(37, 54, 189)"
    },
    cx: 386.978,
    cy: 108.846,
    r: 3.518
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEzcash);
export default __webpack_public_path__ + "static/media/ezcash.65821bb63f61d1a1e4ee86d1fb649f38.svg";
export { ForwardRef as ReactComponent };